import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getVehicles } from "services/http/vehicles";
import { getDrivers } from "services/http/drivers";

export const fetchMyAnalyticsAsync = createAsyncThunk(
  "analytics/fetchMyAnalytics",
  async (_, { rejectWithValue }) => {
    try {
      const vehiclesResp = await getVehicles({});
      const driversResp = await getDrivers({ params: { drivers: true } });
      return {
        vehicles: vehiclesResp.length,
        drivers: driversResp.length,
      };
    } catch (error) {
      return rejectWithValue({
        statusCode: error?.status,
      });
    }
  },
);

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: { data: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMyAnalyticsAsync.fulfilled, (state, action) => {
      state.data.me = action.payload;
    });
  },
});

export const getMyAnalytics = () => (dispatch) =>
  dispatch(fetchMyAnalyticsAsync()).unwrap();

export default analyticsSlice.reducer;
